import { render, staticRenderFns } from "./ITeamPicker.vue?vue&type=template&id=8aa06518&"
import script from "./ITeamPicker.vue?vue&type=script&lang=js&"
export * from "./ITeamPicker.vue?vue&type=script&lang=js&"
import style0 from "./ITeamPicker.vue?vue&type=style&index=0&id=8aa06518&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports